'use client'
import React from 'react'
import ReactPaginate from 'react-paginate'
import './styles.scss'
import LeftArrow from './LeftArrow'
import RightArrow from './RightArrow'
import { useBreakpoint } from '@l2p/apps-shared'

interface PaginationProps {
  initialActivePage?: number
  count: number
  handlePageClick: (e: { nextSelectedPage?: number; selected?: number }) => void
  forcePage?: number
}

const Pagination: React.FC<PaginationProps> = ({
  initialActivePage,
  forcePage,
  handlePageClick,
  count,
}) => {
  const breakpoints = useBreakpoint()
  return (
    <div className="pagination-container">
      <ReactPaginate
        breakLabel="..."
        initialPage={initialActivePage}
        nextLabel={<RightArrow />}
        onClick={handlePageClick}
        pageRangeDisplayed={breakpoints.mobile ? 1 : breakpoints.tablet ? 3 : 5}
        forcePage={forcePage}
        pageCount={count}
        previousLabel={<LeftArrow />}
        marginPagesDisplayed={1}
      />
    </div>
  )
}

export default Pagination
